import { render, staticRenderFns } from "./CoozzyHandoverIcon.vue?vue&type=template&id=3b15ad3b&scoped=true"
import script from "./CoozzyHandoverIcon.vue?vue&type=script&lang=js"
export * from "./CoozzyHandoverIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b15ad3b",
  null
  
)

export default component.exports